<template>
    <div :class="phoneClass || 'newAdd'">
        <div class="device-nub" v-if="show">
            <div class="table-outer-status">
                <h1 >
                    {{$t('devicePage.device')}}
                    <div>
                        <el-alert v-if="detail.status === 0"
                            :title="$t('selectData.device.status.status0')"
                            type="success"
                            style="color:#46962b"
                            :closable="false">
                        </el-alert>
                        <el-alert v-else-if="detail.status === 1"
                            :title="$t('selectData.device.status.status1')"
                            type="warning"
                            style="color:#eb202a"
                            :closable="false">
                        </el-alert>
                        <el-alert v-else-if="detail.status === 2"
                            :title="$t('selectData.device.status.status2')"
                            type="error"
                            style="color:#ff8004"
                            :closable="false">
                        </el-alert>
                        <el-alert v-else-if="detail.status === 3"
                            :title="$t('selectData.device.status.status3')"
                            type="info"
                            style="color:black;background: #9ea0a2"
                            :closable="false">
                        </el-alert>
                        <el-alert v-else-if="detail.status === 4"
                            :title="$t('selectData.device.status.status4')"
                            type="info"
                            style="color:black;background: #9ea0a2"
                            :closable="false">
                        </el-alert>
                    </div>
                </h1>
            </div>
            <!--禁用启用-->
            <!--<div class="clickBan">-->
                    <!--<el-button type="primary" @click="push">复位</el-button>-->
                <!--&lt;!&ndash;<el-tooltip :content="$t('message.click_disable')" placement="top" v-if="!detail.is_enable">&ndash;&gt;-->
                    <!--&lt;!&ndash;<el-button class="banOn" @click="deleteDevice()"><img src="../assets/img/icon/authority-no.png" alt="">{{$t('message.start')}}</el-button>&ndash;&gt;-->
                <!--&lt;!&ndash;</el-tooltip>&ndash;&gt;-->
                <!--&lt;!&ndash;<el-tooltip :content="$t('message.click_enable')" placement="top" v-else>&ndash;&gt;-->
                    <!--&lt;!&ndash;<el-button class="banOff" @click="deleteDevice()"><img src="../assets/img/icon/authority-off.png" alt="">{{$t('message.disables')}}</el-button>&ndash;&gt;-->
                <!--&lt;!&ndash;</el-tooltip>&ndash;&gt;-->
            <!--</div>-->
            <!--<el-button @click="delBt" type="danger" class="del-bt"><i class="el-icon-delete"></i> 删除设备</el-button>-->
            <span>{{$t('devicePage.add.lubricant_left')}}：{{lubricant_left >= 0 ? lubricant_left + '%' : '-'}}</span>
            <span>{{$t('devicePage.add.lubricant_available_days')}}：{{lubricant_available_days>=0 ? (lubricant_available_days/7).toFixed(1) + $t('devicePage.week') :'-'}} </span>
            <p></p>
        </div>

        <div class="device-nub" v-else>
            <h1>{{$t('sideBar.newEquipment')}}</h1>
        </div>
        <div class="device-tab">
            <div>
                <p>{{$t('devicePage.type')}}</p>
                <!--<el-input v-model="load" placeholder="请输入荷载情况"></el-input>-->
                <template>
                    <el-select v-model="type" :placeholder="$t('message.select')" @change="handleTypeChange">
                        <el-option
                            v-for="item in types"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </template>
            </div>
            <div>
                <p>{{$t('devicePage.add.industry')}}</p>
                <el-autocomplete
                        popper-class="my-autocomplete"
                        v-model="industry"
                        :fetch-suggestions="querySearchOne"
                        :placeholder="$t('message.message')"
                        @select="handleSelectOne">
                    <i
                            class="el-icon-edit el-input__icon"
                            slot="suffix"
                            @click="handleIconClick">
                    </i>
                    <template slot-scope="props">
                        <div class="name">{{ props.item.value }}</div>
                        <span class="addr">{{ props.item.address }}</span>
                    </template>
                </el-autocomplete>
            </div>

            <div v-if="this.type === 0">
                <p>{{$t('devicePage.imei')}}</p>
                <el-input v-model="imei" :disabled="deviceId > 0" :placeholder="$t('message.enter')"></el-input>
            </div>


            <div v-show="this.type === 1">
                <p>{{$t('devicePage.eui')}}</p>
                <el-select
                    v-model="eui"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入关键词"
                    :remote-method="querySearchEui"
                    @change="addrCheck"
                    :loading="loadingEui">
                    <el-option
                        v-for="(item, key) of euiList"
                        :key="key"
                        :label="item.imei"
                        :value="item.imei"
                    >
                    </el-option>
                </el-select>
            </div>
<!--            <div v-show="this.type === 1">
                <p>{{$t('devicePage.gateway_eui')}}</p>
                <el-select
                    class="gateway-select"
                    v-model="gatewayId"
                    filterable
                    remote
                    reserve-keyword
                    :placeholder="$t('message.enter')"
                    :remote-method="getGatewayAll"
                    :loading="loadingGateway">
                    <el-option
                        v-for="item in gatewayList"
                        :key="item.id"
                        :label="item.eui"
                        :value="item.id">
                    </el-option>
                </el-select>
                <el-button
                    class="gateway-button"
                    @click="addGatewayLoading"
                >添加网关</el-button>
            </div>-->
            <div v-show="this.type === 1">
                <p>{{$t('devicePage.addr')}}</p>
                <el-input v-model="addr" disabled :placeholder="$t('message.enter')"></el-input>
            </div>
            <div v-show="this.type === 1">
                <p>{{$t('devicePage.nwks_key')}}</p>
                <el-input v-model="nwksKey" disabled :placeholder="$t('message.enter')"></el-input>
            </div>
            <div v-show="this.type === 1">
                <p>{{$t('devicePage.apps_key')}}</p>
                <el-input v-model="appsKey" disabled :placeholder="$t('message.enter')"></el-input>
            </div>

            <div>
                <p>{{$t('devicePage.application')}}</p>
                <el-autocomplete
                        popper-class="my-autocomplete"
                        v-model="application"
                        :fetch-suggestions="querySearchTwo"
                        :placeholder="$t('message.message')"
                        @select="handleSelectTwo">
                    <i
                            class="el-icon-edit el-input__icon"
                            slot="suffix"
                            @click="handleIconClick">
                    </i>
                    <template slot-scope="props">
                        <div class="name">{{ props.item.value }}</div>
                        <span class="addr">{{ props.item.address }}</span>
                    </template>
                </el-autocomplete>
            </div>

            <!--设备编号-->
            <div>
                <p>{{$t('devicePage.lubricator_number')}}</p>
                <el-input v-model="slipNum" :placeholder="$t('message.enter')"></el-input>
                <!--<template>-->
                    <!--<el-select v-model="asset_tag" filterable placeholder="请输入或选择润滑剂">-->
                        <!--<el-option-->
                                <!--v-for="item in asset_tags"-->
                                <!--:key="item.value"-->
                                <!--:label="item.label"-->
                                <!--:value="item.value">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                <!--</template>-->
            </div>
            <div>
                <p>{{$t('devicePage.deviceName')}}</p>
                <el-autocomplete
                    popper-class="my-autocomplete"
                    v-model="name"
                    :fetch-suggestions="querySearchThree"
                    :placeholder="$t('message.message')">
                    <i
                            class="el-icon-edit el-input__icon"
                            slot="suffix"
                            @click="handleIconClick">
                    </i>
                    <template slot-scope="props">
                        <div class="name">{{ props.item.value }}</div>
                        <span class="addr">{{ props.item.address }}</span>
                    </template>
                </el-autocomplete>
            </div>
            <!--润滑脂筒规格-->
            <div>
                <p>{{$t('devicePage.lubricant_specifications')}}</p>
                <template>
                    <el-select v-model="slip_tube" filterable :placeholder="$t('message.select')">
                        <el-option
                                v-for="item in slip_tubes"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </template>
            </div>
            <!--安装位置-->
            <div>
                <p>{{$t('devicePage.install_location')}}</p>
                <el-autocomplete
                        popper-class="my-autocomplete"
                        v-model="position"
                        :fetch-suggestions="querySearchPosition"
                        :placeholder="$t('message.message')">
                    <i
                            class="el-icon-edit el-input__icon"
                            slot="suffix"
                            @click="handleIconClick">
                    </i>
                    <template slot-scope="props">
                        <div class="name">{{ props.item.value }}</div>
                        <span class="addr">{{ props.item.address }}</span>
                    </template>
                </el-autocomplete>
            </div>
            <div>
                <p>{{$t('devicePage.lubricant')}}</p>
                <template>
                    <el-autocomplete
                            popper-class="my-autocomplete"
                            v-model="slip"
                            :fetch-suggestions="querySearchSlip"
                            :placeholder="$t('message.message')">
                        <i
                                class="el-icon-edit el-input__icon"
                                slot="suffix"
                                @click="handleIconClick">
                        </i>
                        <template slot-scope="props">
                            <div class="name">{{ props.item.value }}</div>
                            <span class="addr">{{ props.item.address }}</span>
                        </template>
                    </el-autocomplete>
                    <!--<el-select v-model="slip" filterable placeholder="请输入或选择润滑剂">-->
                        <!--<el-option-->
                                <!--v-for="item in slips"-->
                                <!--:key="item.value"-->
                                <!--:label="item.label"-->
                                <!--:value="item.name">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                </template>
            </div>
            <!--资产标签-->
            <div>
                <p>{{$t('devicePage.asset_label')}}</p>
                <el-input v-model="asset_tag" :placeholder="$t('message.enter')"></el-input>
            </div>
            <!--<div>-->
                <!--<p>资产名称</p>-->
                <!--<el-input v-model="asset_name" placeholder="请输入内容"></el-input>-->
            <!--</div>-->
            <div v-show="this.type === 1">
                <p>{{$t('devicePage.lora_band')}}</p>
                <el-select v-model="lora_band" :placeholder="$t('message.select')">
                    <el-option
                        v-for="item in loraBandList"
                        :key="item"
                        :label="item"
                        :value="item"
                        :loading="loadingGateway">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="time-lnglat">
            <!-- 时间设置 -->
            <div class="time-set">
                <p>{{$t('devicePage.time_setting')}}
                    <el-tooltip :content="$t('devicePage.time_setting_tip')" popper-class="form-tooltip" placement="right">
                        <i class="el-icon-warning-outline"/>
                    </el-tooltip>
                </p>
                <el-select v-model="time" :placeholder="$t('message.select')">
                    <el-option v-for="item in setTime" :key="item.value" :label="$t('selectData.set_time.month'+item.value)" :value="item.value" />
                </el-select>
            </div>
        </div>

        <!--上报周期-->
        <div v-if="user.role === 2 || user.role === 10 ">
            <p>{{$t('devicePage.reporting_cycle')}}</p>
            <template>
                <el-select v-model="hour" :placeholder="$t('message.select')">
                    <el-option
                            v-for="item in hours"
                            :key="item.value"
                            :label="$t('selectData.hours.hour'+item.value)"
                            :value="item.value"
                            :disabled="item.disabled">
                    </el-option>
                </el-select>
            </template>
        </div>
        <div v-if="user.role === 2 || user.role === 10 "></div>
        <!--位置图-->
        <div class="position-pic">
            <p>{{$t('devicePage.location_map')}}</p>
            <el-upload
                class="avatar-uploader"
                :action="imageUrl"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="img" :src="img" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <!--<img :src="img" >-->
        </div>
        <!--选填-->
        <div class="device-nub">
            <h5>{{$t("devicePage.optional")}}</h5>
            <p></p>
        </div>
        <div class="device-tab">
            <div>
                <p>{{$t(/* 轴承型号 */'devicePage.bearing_type')}}</p>
                <el-input v-model="bearing" :placeholder="$t('message.enter')"></el-input>
            </div>
            <div>
                <p>{{$t(/* 转速 (Rpm) */'devicePage.speed')}}</p>
                <el-input v-model="speed" :placeholder="$t('message.enter')"></el-input>
            </div>
            <div>
                <p>{{$t(/* 轴承工作温度 */'devicePage.bearing_temperature')}}</p>
                <el-select clearable v-model="temperature" :placeholder="$t('message.select')">
                    <el-option v-for="item in temperatures" :key="item.value" :label="item.label" :value="item.value"/>
                </el-select>
            </div>
            <div>
                <p>{{$t(/* 荷载情况 */'devicePage.load_condition')}}</p>
                <el-select clearable v-model="load" :placeholder="$t('message.select')">
                    <el-option v-for="item in loads" :key="item.value" :label="item.label" :value="item.value"/>
                </el-select>
            </div>

            <!-- 经纬度设置  -->
            <div class="lnglat">
                <div class="inputs-block">
                    <p>{{$t('devicePage.lnglat')}}</p>
                    <a href="https://lbs.amap.com/tools/picker" target="_blank">{{$t('devicePage.getlnglat')}}</a>
                </div>
                <div class="inputs">
                    <el-input v-model="longitude" placeholder="请输入经度" class="longitude">
                        <template slot="prepend">经度</template>
                    </el-input>
                    <el-input v-model="latitude" placeholder="请输入纬度">
                        <template slot="prepend">纬度</template>
                    </el-input>
                </div>
            </div>
            <div v-if="user.role === 100">
                <p>{{$t('devicePage.group')}}</p>
                <!--<el-input v-model="groupId" placeholder="请输入内容"></el-input>-->
                <template>
                    <el-select clearable v-model="groupId" :placeholder="$t('message.select')">
                        <el-option
                                v-for="item in groupList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </template>
            </div>
        </div>
        <div class="device-bt">
            <el-button v-if="show" type="primary" @click="pushNew">{{$t('message.preserved')}}</el-button>
            <el-button v-else type="primary" @click="pushNew">{{$t('devicePage.addition')}}</el-button>
            <el-button @click="closeBt">{{$t('devicePage.close')}}</el-button>
        </div>
        <el-dialog width="450px" title="添加网关" :visible.sync="loadingAddGateway" class="detail-change" :before-close="addGatewayLoadingEnd" >
            <div class="dialog">
                <div class="dialog-top">
                    <span style="">{{$t('gatewayPage.eui')}} :</span>
                    <el-input v-model="gateway.eui" :placeholder="$t('message.enter')"></el-input>
                </div>

                <div class="dialog-content">
                    <span style="font-size: 14px;color: #363D42;">{{$t('gatewayPage.name')}}:</span>
                    <el-input v-model="gateway.name" :placeholder="$t('message.enter')"></el-input>
                </div>
            </div>
            <div class="dialog-bottom">
                <el-button class="cancel" @click="addGatewayLoadingEnd">取消</el-button>
                <el-button type="primary" class="confirm" @click="addGateway">确认</el-button>
            </div>
        </el-dialog>

    </div>

</template>

<script>
    import Core from 'core/core'
    import index from "../../core/filters";
    import {refresh} from "core/winSize"
    import i18n from "@/locales";
    export default {
        name: "device-add-new",
        data() {
            return {
                phoneClass: '',
                user: '',
                deviceId: '',
                show: false,
                industrys: [],
                industry: '',      //行业
                imei: '',       //润滑器编号
                labels: [],
                label: '',     //资产标签
                applications: [],
                application: '',//应用
                asset_tags: [],
                asset_tag: '',  //资产标签
                asset_name: '', //资产名称
                names: [],
                name: '', //设备名称
                slipNum: '', //设备编号
                slip_tubes: Core.Const.slip_tubes,
                slip_tube: '',//润滑脂桶规格
                slips: [],
                slip:'',       //润滑剂
                positions: [],
                position: '',  //安装位置
                setTime: [],
                time: '',  //设置
                timeVale: '',
                addr: '',
                nwksKey: '',
                appsKey: '',
                imageUrl: Core.Const.NET.IMPORT_FILE + 'img-upload',
                bearing: '',    //轴承
                speed: '',      //转速
                temperatures: Core.Const.temperatures,
                temperature: '',//温度
                loads: Core.Const.loads,
                types: Core.Const.deviceType,
                gatewayList: [],
                loadingGateway: false,
                loadingLoraBand: false,
                hour: 24,
                hours: Core.Const.hours,
                load: '',        //荷载
                address: '',
                img: '',
                imageData: '',
                eui: '',
                type: 0,
                gatewayId: '',
                loadingAddGateway: false,
                gateway: {
                  eui: '',
                  name: ''
                },
                restaurantsOne: [],
                restaurantsTwo: [],
                restaurantsThree: [],
                restaurantsPosition: [],
                restaurantsSlip: [],
                euiList: [],
                loraBandList: [],
                loadingEui: false,
                state3: '',
                is_enable: '',   //状态
                detail: '',
                lubricant_available_days: '',
                lubricant_left: '',
                groupId: '',
                groupList: [],
                longitude: '', // 经度
                latitude: '',  // 纬度
                lora_band: '', // 频段
            };
        },
        created(){
	        refresh(this,'phoneClass-newAdd');
	        window.onresize = function(){
		        setTimeout(function(){
			        refresh(this,'phoneClass-newAdd');
		        },10)
	        };
        },
        mounted(){
            this.initListAll()
            this.initUser()
            this.deviceId=this.$route.query.device_id;
            Core.Api.Config.getIndustryList().then(res => {
                this.industrys = res.application_list
                this.restaurantsOne = this.loadAllOne();
            })
            this.getGatewayAll("")
            this.getLoraBandAll()
            //安装位置
            Core.Api.Config.getInstallListL().then(res => {
                this.positions=res.application_list
                this.restaurantsPosition = this.loadAllPosition();
            })
            //润滑剂
            Core.Api.Config.getLubricantList().then(res => {
                this.slips=res.application_list
                this.restaurantsSlip = this.loadAllSlip();
            })
            if (this.deviceId){
                //编辑
                this.show = !this.show
                this.getDeviceList()
            } else {
                this.setTime = Core.Const.month
            }
        },
        methods: {
	        // timeSelect (e) {
		    //     console.log (e)
		    //     if (e === 13) {
		    //         this.time = this.timeValue
		    //         this.push()
		    //     } else {
		    //         this.timeValue = e
		    //     }
	        // },
	        // push (){
		    //     console.log (this.imei)
		    //     Core.Api.Device.resetDevice(this.imei).then((res)=>{
			//         this.$message.success('已复位');
			//         this.initListAll()
			//         this.getDeviceList()
		    //     })
            //
	        // },
            initListAll(){
                Core.Api.Group.listAll().then((res)=>{
                    console.log(res)
                    let arr = []
                    res.group_list.map((item)=>{
                        arr.push({
                            value: item.id,
                            label: item.name
                        })
                    })
                    this.groupList = arr
                    // console.log(arr,'arr')
                })
            },
            initUser() {
                this.user = Core.Data.getUser()
            },
            getDeviceList() {
                Core.Api.Device.getDeviceDetail(this.deviceId).then(res => {
                    console.log("getDeviceDetail res", res);
                    this.detail = res
                    this.industry = res.industry
                    this.imei = res.imei
                    this.application = res.application
                    this.asset_name = res.asset_name
                    this.asset_tag = res.asset_tag
                    this.name = res.name
                    this.slipNum = res.device_sn
                    this.slip_tube = res.lubricant_tube
                    this.slip = res.lubricant
                    this.position = res.install_location
                    this.time = res.setting
                    this.timeValue = res.setting
                    this.imageData = res.image
                    res.image ? this.img = Core.Const.NET.IMG_URL_PREFIX + res.image : ''
                    this.bearing = res.bearing_type
                    this.speed = res.rpm
                    this.temperature = res.bearing_temperature
                    this.groupId = res.group_id
                    this.load = res.load
                    this.lubricant_left = res.lubricant_left
                    this.lubricant_available_days = res.lubricant_available_days
                    this.hour = res.report_interval
                    this.eui = res.eui
                    /* if (res.gateway_id !== 0){
                        this.gatewayId = res.gateway_id
                    }*/
                    this.addr = res.addr
                    this.nwksKey = res.nwks_key
                    this.appsKey = res.apps_key
                    this.type = res.type
                    this.getGatewayAll(res.gateway_eui)
                    this.longitude = res.longitude
                    this.latitude = res.latitude
                    this.lora_band = res.lora_band
                    this.setTimeByVersion();
                })
            },
            handleTypeChange() {
                this.setTimeByVersion()
            },
            setTimeByVersion() {
                console.log('setTimeByVersion software_version:', this.detail.software_version)
                // 区分1-12 ｜ 1-24 个月时间设置的版本号（大于等于)
                const versionMap = {
                    '0': 'V1.5.20230522', // NB
                    '1': '020101', // Lora 0x020101 131329
                }
                const compareVersion = versionMap[this.type + '' || '0'];
                if (this.detail.software_version) {
                    let result = Core.Util.compareVersion(this.detail.software_version, compareVersion);
                    console.log('compareVersion result:', result)
                    result === -1 ? (this.setTime = Core.Const.oldMonth) : (this.setTime = Core.Const.month)
                } else {
                    this.setTime = Core.Const.month;
                }
                console.log('setTime:', this.setTime)

                if (this.time !== '' && this.time !== undefined) {
                    let item = this.setTime.find(i => i.value === this.time)
                    if (!item) {
                        this.time = 12
                    }
                }
            },
            handleAvatarSuccess(res, file) {
                console.log(file,'imgfile');
                this.img = URL.createObjectURL(file.raw);
                this.imageData = file.response.data.name
                console.log(this.imageData);
                this.loading.close()
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg';
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.error('上传图片只能是 JPG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!');
                }
                this.loading = this.$loading({
                    lock: true,
                    text: 'Uploading',
                });
                return isJPG && isLt2M;
            },
            closeBt(){
                this.$router.push({path:'/device'})
                window.scrollTo(0,0);
            },
            // deviceId: '',
            // show: false,
            // industrys: [],
            // industry: '',      //行业
            // imei: '',       //设备编号
            // label: '',     //资产标签
            // application: '',//应用
            // asset_tag: '',  //资产编号
            // name: '', //设备名称
            // slip_tube: '',//润滑脂桶规格
            // slip:'',       //润滑剂
            // position: '',  //安装位置
            // time: '',  //设置
            // imageUrl: '',
            // bearing: '',    //轴承
            // speed: '',      //转速
            // temperature: '',//温度
            // load: ''        //荷载
            pushNew(){
                // console.log('save time >>', this.time);
                // return;
                console.log(this.type);
                if (this.industry && this.application && this.name && this.slipNum && this.asset_tag  &&
                    this.position && this.slip_tube && this.slip && ((this.imei && this.type === 0)||(this.eui && this.addr && this.nwksKey && this.appsKey && this.type === 1)) && (this.time || this.time === 0)) {
                    if(typeof(this.time) === 'string' ) {
                        this.time = this.timeValue
                    }
                    if (this.type === 0){
                        console.log('this.longitude: ', this.longitude);
                        console.log('this.latitude: ', this.latitude);
                        Core.Api.Device.saveDevice(
                            this.deviceId,
                            this.industry,      //行业
                            this.application,   //应用
                            this.name,          //设备名称
                            this.slipNum,       //设备编号
                            this.asset_tag,     //资产标签
                            this.asset_name,    //资产名称
                            this.position,      //安装位置
                            this.slip_tube,     //润滑脂桶规格
                            this.slip,          //润滑剂
                            this.time,          //时间
                            this.imei,          //润滑器编号
                            this.imageData,      //图片
                            this.bearing,       //轴承
                            this.speed,         //转速
                            this.temperature,   //温度
                            this.load,          //荷载
                            this.address,       //详细地址
                            this.groupId,        //分组
                            24,
                            this.longitude,     // 经度
                            this.latitude,      // 纬度
                        ).then(res => {
                            // console.log(this.time)
                            if (this.deviceId) {
                                this.$message.success('修改成功');
                            } else {
                                this.$message.success('新增成功');
                            }
                        }).then(()=>{
                            this.closeBt()
                        })
                    } else {
                        Core.Api.Device.saveDeviceLora(
                            this.deviceId,
                            this.industry,      //行业
                            this.application,   //应用
                            this.name,          //设备名称
                            this.slipNum,       //设备编号
                            this.asset_tag,     //资产标签
                            this.asset_name,    //资产名称
                            this.position,      //安装位置
                            this.slip_tube,     //润滑脂桶规格
                            this.slip,          //润滑剂
                            this.time,          //时间
                            this.imageData,      //图片
                            this.bearing,       //轴承
                            this.speed,         //转速
                            this.temperature,   //温度
                            this.load,          //荷载
                            this.address,       //详细地址
                            this.groupId,        //分组
                            this.eui,        //分组
                            // this.gatewayId,        //分组
                            this.addr,
                            this.nwksKey,
                            this.appsKey,
                            24,
                            this.longitude,     // 经度
                            this.latitude,      // 纬度
                            this.lora_band,
                        ).then(res => {
                            // console.log(this.time)
                            if (this.deviceId) {
                                this.$message.success('修改成功');
                            } else {
                                this.$message.success('新增成功');
                            }
                        }).then(()=>{
                            this.closeBt()
                        })
                    }

                }  else {
	                console.log (this.industry , this.application , this.name , this.slipNum , this.asset_tag ,
		                this.position , this.slip_tube , this.slip , this.imei , (this.time || this.time === 0) ,
		                this.hour)
	                this.$message.error('请将必填资料填写完整');

                }
            },
            querySearchOne(queryString, cb) {
                if (this.restaurantsOne) {
                    var restaurants = this.restaurantsOne;
                    var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                    // 调用 callback 返回建议列表的数据
                    cb(results);
                }
            },
            handleSelectOne() {
                Core.Api.Config.getApplicationList(this.industry).then(res => {
                    this.applications=res.application_list
                    this.restaurantsTwo = this.loadAllTwo();
                })
            },
            querySearchTwo(queryString, cb) {
                if (this.restaurantsTwo) {
                    var restaurants = this.restaurantsTwo;
                    var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                    // 调用 callback 返回建议列表的数据
                    cb(results);
                }
            },
            handleSelectTwo() {
                Core.Api.Config.getDeviceList(this.application).then(res => {
                    // console.log(this.application);
                    // console.log(res,'name');
                    this.names=res.device_name_list
                    this.restaurantsThree = this.loadAllThree();
                })
            },
            querySearchThree(queryString, cb) {
                var restaurants = this.restaurantsThree;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            querySearchPosition(queryString, cb){
                var restaurants = this.restaurantsPosition;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            querySearchEui(queryString){
                if (queryString !== '') {
                    this.loadingEui = true;
                    setTimeout(() => {
                        this.loadingEui = false;
                        Core.Api.Storage.getEuiListAll(queryString).then(res => {
                            this.euiList=res.storage_list
                            console.log(this.euiList)
                        })
                    }, 200);
                } else {
                    this.options = [];
                }
            },
            addrCheck(imei){
                let item = this.euiList.find(i => i.imei === imei)
                if (item !== undefined){
                    this.addr = item.addr
                    this.appsKey = item.apps_key
                    this.nwksKey = item.nwks_key
                }
            },
            querySearchSlip(queryString, cb){
                var restaurants = this.restaurantsSlip;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            loadAllOne() {
                let arr=[]
                for (let x in this.industrys) {
                    arr.push({"value":this.industrys[x].name})
                }
                return arr
            },
            loadAllTwo() {
                let arr=[]
                for (let x in this.applications) {
                    arr.push({"value":this.applications[x].name})
                }
                return arr
            },
            loadAllThree() {
                let arr=[]
                for (let x in this.names) {
                    arr.push({"value":this.names[x].name})
                }
                return arr
            },
            loadAllPosition(){
                let arr=[]
                for (let x in this.positions) {
                    arr.push({"value":this.positions[x].name})
                }
                return arr
            },
            loadAllSlip(){
                let arr=[]
                for (let x in this.slips) {
                    arr.push({"value":this.slips[x].name})
                }
                return arr
            },
            handleIconClick(ev) {
                console.log(ev);
            },
            deleteDevice() {
                if(this.deviceId){
                    const ths = this;
                    if(!this.detail.is_enable){
                        this.$confirm('您确定要禁用该设备吗？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            Core.Api.Device.enable(this.deviceId).then((res)=>{
                                ths.getDeviceList()
                            })
                            this.$message({
                                type: 'success',
                                message: '禁用成功!'
                            });
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消禁用'
                            });
                        });
                    } else {
                        Core.Api.Device.enable(this.deviceId).then((res)=>{
                            ths.getDeviceList()

                        })
                    }
                }

            },
            getGatewayAll (query) {
                this.loadingGateway = true;
                console.log(query)
                setTimeout(() => {
                    this.loadingGateway = false;
                    Core.Api.Gateway.list(query, "", 1, 10).then(res => {
                        this.gatewayList = res.list
                    })
                }, 200);

            },
            getLoraBandAll(query) {
                this.loadingLoraBand = true;
                console.log(query)
                setTimeout(() => {
                    this.loadingLoraBand = false;
                    Core.Api.Fengine.getLoraBandList().then(res => {
                        this.loraBandList = res.list
                    })
                }, 200);

            },
            addGatewayLoading(){
                this.loadingAddGateway = true;
            },
            addGatewayLoadingEnd(){
                this.gateway.eui = ''
                this.gateway.name = ''
                this.loadingAddGateway = false;
            },
            addGateway(){
                let info = this.gateway;
                if (info.name && info.eui) {
                    Core.Api.Gateway.save('', this.gateway.eui, this.gateway.name).then(res => {
                        this.getGatewayAll()
                        this.addGatewayLoadingEnd()
                        this.loadingAddGateway = false;
                    })
                } else {
                    this.$message.error(i18n.t('message.complete_information'));



                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .newAdd{
        .device-nub {
            >h1{
                font-size: 20px;
                font-weight: 500;
            }
            h5 {
                margin-top: 30px;
            }
            >span {
                font-size: 12px;
                width: 40%;
                display: inline-block;
                margin: 10px 0;
            }
            >p {
                height: 1px;
                width: 94.5%;
                background: #eef0f5;
                margin: 10px 0;
            }

        }
        .device-tab{
            width: 70vw;
            /*display: flex;*/
            >div{
                display: inline-block;
                width: 45%;
                margin: 10px 3vw 10px 0;
                >p {
                    font-size: 14px;
                    color: #7A8799;
                    margin: 0 0 10px 0;
                }
                .el-select {
                    width: 100%;
                    height: 40px;
                }
                .gateway-select{
                    width: 80%;
                    height: 40px;
                }
                .gateway-button{
                    width: 20%;
                    height: 40px;
                }
            }
        }
        .device-bt {
            margin-top: 30px;
        }
    }
    .detail-change {
        .dialog {
            margin: 20px;

            .dialog-top {
                margin: 10px;
                .content {
                    margin-left: 10px;
                    display: inline;
                }
            }
            .dialog-content {
                margin: 10px;
            }
            .dialog-select {
                margin: 5px 10px 10px 10px;
                display: inline-block;
            }
        }
        .dialog-bottom {
            display: flex;
            flex-direction: row-reverse;
            align-items: center;
            .confirm {
                margin: 10px 10px;
            }
            .cancel {
                width: 62px;
                height: 28px;
                margin-right: 10px;
            }
        }
    }
    .time-lnglat {
        display: flex;
        &>div {
            width: 45%;
            margin: 10px 3vw 10px 0px;
            p {
                margin-bottom: 10px;
                color: #7A8799;
            }
            .el-select {
                width: 100%;
            }
        }
    }
    .lnglat {
        .inputs-block {
            display: flex;
            color: #7A8799;
            margin-bottom: 10px;
            a {
                color: #0F58D6;
                &:visited {
                    color: #0F58D6;
                }
            }
        }
        .inputs {
            display: flex;
            .el-input-group__prepend {
                color: #000
            }
        }
    }
</style>
<style lang="scss">
    .newAdd {
        width: 70%;
        margin: 30px auto;
        .table-outer-status {
            h1 {
            font-size: 20px;
            }
            h1 >div{
                display: inline-block;
                white-space:nowrap !important;
            }
            .el-alert {
                margin: 0;
                padding: 0;
                min-width: 48px;
                height: 26px;
                font-size: 10px !important;
                /*display: inline-block;*/
                .el-alert__content{
                    margin: 0 auto;
                    padding: 0;
                    .el-alert__title {
                        margin: 0 auto;
                        font-size: 10px !important;

                    }
                }
            }
            .el-alert--success{
                background: #e0f5e5;
                color: #2DBC4F;
            }
            .el-alert--info {
                background: #e8e9fb;
                color: #626BE3;
            }
        }
        /*.clickBan {*/
            /*position: absolute;*/
            /*margin-left: 60vw;*/
            /*img{*/
                /*width: 14px;*/
                /*height: 14px;*/
                /*margin-right: 6px;*/
                /*position: relative;*/
                /*top: 1.5px;*/
            /*}*/
            /*.banOn {*/
                /*color: #00CC83;*/
                /*border:1px #00CA85 solid;*/
            /*}*/
            /*.banOn:hover,.banOn:active,.banOn:focus {*/
                /*background: #eefffa;*/
            /*}*/
            /*.banOff {*/
                /*color: #FF3A00;*/
                /*border: 1px #FF3A00 solid;*/
            /*}*/
            /*.banOff:hover,.banOff:active,.banOff:focus {*/
                /*background: #FFEBE5;*/
            /*}*/
        /*}*/
        .el-autocomplete {
            width: 100%;
            .el-input__icon {
                display: none;
            }
        }
        .my-autocomplete {
            li {
                line-height: normal;
                padding: 7px;

                .name {
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
                .addr {
                    font-size: 12px;
                    color: #b4b4b4;
                }

                .highlighted .addr {
                    color: #ddd;
                }
            }
        }
        .el-tag {
            width: 50px;
            height: 30px;
            margin-left: 15px;
        }
        .el-input__inner {
            height: 40px !important;
        }
        .avatar-uploader .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
        .avatar-uploader .el-upload:hover {
            border-color: #409EFF;
        }
        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 100px;
            height: 100px;
            line-height: 100px;
            text-align: center;
        }
        .avatar {
            width: 100px;
            height: 100px;
            display: block;
        }
        .device-bt .el-button {
            height: 40px;
            width: 110px;
            margin-right: 10px;
        }

        .el-message-box {
            .el-button {
                position: relative;
                right: -55px;
            }
            .el-button--primary {
                position: relative;
                right: 60px;
            }

        }
        .lang-zh {
            width: 100%;
            margin: 0;
            padding: 0;
        }
        .el-popup-parent--hidden {
            padding-right: 0px !important;
        }
    }
    .phoneClass-newAdd {
        width: 80%;
        margin: 30px auto;
        padding-bottom: 60px;
        .device-nub {
            h1 {
                font-size: 20px;
                margin-bottom: 5px;
                position: relative;
                .el-alert {
                    width: 50px;
                    padding: 0;
                    position: absolute;
                    top: 5px;
                    left: 50px;
                    .el-alert__content {
                        text-align: center;

                        margin: 0 auto;
                        .el-alert__title {
                        }
                    }
                }
            }
            h5 {
                font-size: 16px;
                margin-bottom: 5px;
            }
            span {
                display: block;
            }
        }
        .device-tab {
            >div {
                margin-bottom: 10px;
                >p {
                    font-size: 14px;
                    color: #7A8799;
                    margin-bottom: 5px;
                }
            }
        }
        .el-autocomplete,.el-select{
            width: 100%;
        }
        .el-icon-edit {
            display: none;
        }
        /*位置图*/
        .avatar-uploader .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
        .avatar-uploader .el-upload:hover {
            border-color: #409EFF;
        }
        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 100px;
            height: 100px;
            line-height: 100px;
            text-align: center;
        }
        .time-lnglat {
            display: flex;
            flex-direction: column;
            .time-set {
                width: 100%;
            }
            .lnglat {
                width: 100%;
                .inputs {
                    display: flex;
                    flex-direction: column;
                }
                .longitude {
                    margin-bottom: 10px;
                }
            }
        }
    }

    .position-pic {
        p {
            color: #7A8799;
            margin: 10px 3vw 10px 0px;
        }
    }


</style>
